import { useMemo } from 'react'

interface Props {
  zoomStep: number
  maxLength: number
}

const maxCachedDataAmount = 6

export function useZoomsForCache({ zoomStep, maxLength }: Props) {
  return useMemo(() => {
    const array: number[] = []
    for (let i = 0; i < maxCachedDataAmount; i++) {
      const scale = zoomStep ** i
      if (scale > maxLength) {
        break
      }
      array.push(scale)
    }
    return array
  }, [zoomStep, maxLength])
}
